<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/2">
      <Card id="employee-form">
        <form @submit.prevent data-vv-scope="userForm">
          <div class="mb-6 justify-center">
            <AvatarCroperEmployee :curr_image="prefillImage" />
          </div>
          <vs-input
            v-validate="'required|min:3'"
            data-vv-validate-on="blur"
            label="Имя*"
            description-text="Если отсутствует никнейм, то Имя будет отображено на карточке"
            v-model="userForm.first_name"
            :danger="errors.has('userForm.first_name')"
            :danger-text="errors.first('userForm.first_name')"
          />
          <vs-input
            data-vv-validate-on="blur"
            label="Отображаемое имя на карточке профиля (будет видно посетителям)"
            placeholder="Никнейм"
            v-model="userForm.nickname"
            :danger="errors.has('userForm.nickname')"
            :danger-text="errors.first('userForm.nickname')"
          />
          <vs-input
            v-validate="'alpha|min:3'"
            data-vv-validate-on="blur"
            label="Фамилия"
            v-model="userForm.last_name"
            :danger="errors.has('userForm.last_name')"
            :danger-text="errors.first('userForm.last_name')"
          />
          <InputPhone
            label="Телефон*"
            v-model="userForm.phone_number"
            errorsScope="userForm.phone_number"
          />
          <vs-input
            v-validate="'email'"
            data-vv-validate-on="blur"
            type="email"
            label="Почта"
            v-model="userForm.email"
            :danger="errors.has('userForm.email')"
            :danger-text="errors.first('userForm.email')"
          />
          <vs-input
            label="Фраза (будет видно посетителям)"
            v-model="userForm.public_phrase"
            :danger="errors.has('userForm.public_phrase')"
            :danger-text="errors.first('userForm.public_phrase')"
          />
          <vs-button
            button="submit"
            class="mr-3 mb-2"
            :disabled="!validateForm2"
            @click="saveUserProfile('userForm')"
            >Сохранить</vs-button
          >
        </form>
      </Card>
    </div>
    <div class="vx-col md:w-1/2">
      <Card title="Платежные данные">
        <form @submit.prevent data-vv-scope="bankForm">
          <InputAccountNumber
            v-model="form.account_number"
            errorsScope="bankForm.account_number"
          />
          <vs-input
            label="БИК банка, выпустившего карту"
            placeholder="123456789"
            v-model="form.bik"
            v-validate="'required|regex:^[0-9]{9}$'"
            name="bik"
            v-mask="'#########'"
            :danger="errors.has('bankForm.bik')"
            danger-text="БИК должен состоять из 9 цифр"
          />
          <vs-input
            label="ФИО получателя денежных средств"
            placeholder="Иванов Иван Иванович"
            name="account_name"
            v-model.trim="form.account_name"
            v-validate="'required|fullName'"
            :danger="errors.has('bankForm.account_name')"
            danger-text="Введите полное ФИО на кириллице"
          />
          <div class="mb-6">
            <p>
              <small>
                Чтобы узнать реквизиты своего счета:<br>
                В мобильном приложении своего банка выберите карточку,
                на которую хотите получать чаевые, а дальше нажмите - получить реквизиты.
              </small>
            </p>
          </div>
          <vs-button
            button="submit"
            class="mr-3 mb-2"
            :disabled="!validateForm1"
            @click="saveBankAccount('bankForm')"
          >Сохранить</vs-button>
        </form>
      </Card>
    </div>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty.js'
import { mapGetters } from 'vuex'
import { EMPLOYEE_BRANCH_DETACH, EMPLOYEE_UPDATE, USER_BANK_ACCOUNT_CREATE, USER_BANK_ACCOUNT_UPDATE } from '@/store/action.types'
import { REMOVE_EMPLOYEE_BRANCH } from '@/store/mutations.types'
import AuthService from '@/common/auth.service'
import { Form } from '@/common/form'
import AvatarCroperEmployee from '@/views/branches/components/AvatarCroperEmployee'

export default {
  data() {
    return {
      userForm: {},
      form: {}
    }
  },
  components: {
    AvatarCroperEmployee
  },
  computed: {
    validateForm1() {
      // check initial state for update
      return !this.errors.any() && this.form.account_number !== '' && this.form.bik !== '' && this.form.account_name !== ''
    },
    validateForm2() {
      return (
        !this.errors.any() && this.userForm.first_name !== '' && this.userForm.phone_number !== ''
      )
    },
    prefillImage() {
      return this.currentUser.avatar || require('@/assets/images/elements/photo_staff.png')
    },
    ...mapGetters([
      'currentUser',
      'currentUserBankAccount',
      'currentEmployeePhone',
      'currentEmployeeBranch'])
  },
  watch: {
    currentEmployeePhone: function(newVal, oldVal) {
      // currentEmployeePhone позже появляется, чем currentUser
      this.userForm = new Form({
        ...this.userForm,
        'phone_number': this.currentEmployeePhone
      })
    }
  },
  created() {
    if (this.currentUser.bank_account) {
      this.form = new Form(this.currentUserBankAccount)
    }

    this.userForm = new Form({
      first_name: this.currentUser.first_name,
      last_name: this.currentUser.last_name,
      nickname: this.currentUser.nickname,
      avatar: this.currentUser.avatar,
      email: this.currentUser.email,
      public_phrase: this.currentUser.public_phrase,
      phone_number: this.currentEmployeePhone
    })
  },
  mounted() {
  },
  methods: {
    saveUserProfile(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.$vs.loading()
          const employee_payload = {
            id: this.currentUser.id,
            first_name: this.userForm.first_name,
            last_name: this.userForm.last_name,
            public_phrase: this.userForm.public_phrase,
            phone_number: this.userForm.phone_number,
            email: this.userForm.email,
            nickname: this.userForm.nickname,
            avatar: this.avatar,
            notify: this.$vs.notify
          }
          this.$store.dispatch(EMPLOYEE_UPDATE, employee_payload).then(() => {
            this.$vs.loading.close()
            // this.$vs.notify({
            //   title: 'Успешно',
            //   text: 'Данные успешно сохранены',
            // })
          })
        }
      })
    },
    successUpload() {
      this.$vs.notify({
        title: 'Загрузка',
        text: 'Изображение успешно загружено'
      })
    },
    failUpload() {
      this.$vs.notify({
        title: 'Загрузка',
        text: 'Не удалось загрузить изображение'
      })
    },
    getExtension(fileName) {
      return fileName.split('.').pop()
    },
    onChange(image) {
      if (image) {
        this.avatar = image
        const formData = new FormData()
        const extenstion = this.getExtension(this.$refs.pictureInput.file.name)
        const name = Math.random()
          .toString(36)
          .substring(7)
        const avatar = new File(
          [this.$refs.pictureInput.file],
          `${name}.${extenstion}`,
          {
            type: this.$refs.pictureInput.file.type
          }
        )
        formData.append('avatar', avatar)
        AuthService.saveUserImage(formData).then(response => {
          this.successUpload()
        })
      } else {
        this.failUpload()
      }
    },
    detachEmployee() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Открепление от заведения`,
        text: `Вы уверены, что хотите открепиться от заведения?`,
        acceptText: 'Открепиться',
        cancelText: 'Отмена',
        accept: this.acceptEmployeeDetach
      })
    },
    acceptEmployeeDetach() {
      this.$vs.loading()
      const payload = {
        id: this.currentUser.id,
        name: this.currentUser.first_name,
        notify: this.$vs.notify
      }
      this.$store.dispatch(EMPLOYEE_BRANCH_DETACH, payload).then(() => {
        this.$store.commit(REMOVE_EMPLOYEE_BRANCH)
        this.$vs.loading.close()
      })
    },
    isEmpty(obj) {
      return isEmpty(obj)
    },
    saveBankAccount(scope) {
      if (['044525444', '044525416'].includes(this.form.bik)) {
        this.$vs.notify({
          title: 'Ошибка',
          text: 'Вывод на карты и кошельки QIWI и Яндекс не поддерживается из-за правил использования кошельков.'
        })
      } else {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.$vs.loading()
            const payload = {
              'account_number': this.form.account_number,
              'bik': this.form.bik,
              'account_name': this.form.account_name,
              'notify': this.$vs.notify
            }
            if (!this.currentUser.bank_account.account_number) {
              this.$store.dispatch(USER_BANK_ACCOUNT_CREATE, payload).then(() => {
                this.$vs.loading.close()
              })
            } else {
              this.$store.dispatch(USER_BANK_ACCOUNT_UPDATE, payload).then(() => {
                this.$vs.loading.close()
              })
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
</style>
